'use client'

import { ReactNode } from 'react'

import { Button, PageLayout } from '~/components/component-library'

// Educational replacement for a feature page's table view when the team has no activity yet.
export const FeatureEmptyState = ({
  title,
  paragraphs,
  learnMoreUrl,
  createButton,
  showTitle = true,
}: {
  title: string
  paragraphs: string[]
  learnMoreUrl: string
  createButton: ReactNode
  showTitle?: boolean
}) => {
  return (
    <PageLayout title={showTitle ? title : undefined}>
      <div className="space-y-8">
        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="secondary"
            href={{ path: learnMoreUrl, target: 'tab' }}
          >
            Learn more
          </Button>
          {createButton}
        </div>
      </div>
    </PageLayout>
  )
}
